import { render, staticRenderFns } from "./myRequest.vue?vue&type=template&id=4e680e94&scoped=true&"
import script from "./myRequest.vue?vue&type=script&lang=js&"
export * from "./myRequest.vue?vue&type=script&lang=js&"
import style0 from "./myRequest.vue?vue&type=style&index=0&id=4e680e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e680e94",
  null
  
)

export default component.exports